// import request from '@/utils/request'
import { getRouters } from '@/utils/menu';
import { defaultRoutes } from '@/router';
import Layout from '@/layout/MainLayout';
import ParentView from '@/components/ParentView/index.vue';
// 匹配src/views目录下所有.vue文件（含子目录）
const files = require.context('@/views', true, /\.vue$/)
const modules = files.keys().reduce((acc, key) => {
  acc[key] = () => import(`@/views/${key.replace('./', '')}`)
  return acc
}, {})
import { createCustomNameComponent } from '@/utils/createCustomNameComponent';

//初始化state
const state = {
  sidebarRouters:[],
  routesGenerated: false
}
  
  //定义getter
  const getters = {
    
  }

  //定义同步的操作，即mutation
const mutations = {
    setSidebarRouters(state, sidebarRouters){
      state.sidebarRouters = sidebarRouters;
    },
    setRoutesGenerated(state, routesGenerated){
      state.routesGenerated = routesGenerated;
    }
}

//定义异步的操作，即action
const actions = {
  /**
   * 遍历后台传来的路由字符串，转换为组件对象
   * @param asyncRouterMap 后台传来的路由字符串
   * @param lastRouter 上一级路由
   * @param type 是否是重写路由
   */
 async filterAsyncRouter({commit},{asyncRouterMap, lastRouter, type}){
    return asyncRouterMap.filter(async (route) => {
      if(route?.meta?.title == "菜单管理"){//企业端没有菜单管理页面
        route.hidden = true;
      }
      if (type && route.children) {
        route.children = await this.dispatch('permission/filterChildren',{childrenMap:route.children, lastRouter:undefined});
      }
      // Layout ParentView 组件特殊处理
      if (route.component?.toString() === 'Layout') {
        route.component = Layout;
      } else if (route.component?.toString() === 'ParentView') {
        route.component = ParentView;
      } 
      else {
        route.component = await this.dispatch('permission/loadView',{view:route.component,name: route.name});
      }

      if (route.children != null && route.children && route.children.length) {
        route.children = await this.dispatch('permission/filterAsyncRouter',{asyncRouterMap:route.children, lastRouter:route, type});
      } else {
        delete route.children;
        delete route.redirect;
      }
      if(lastRouter){
        route.parentRoute = lastRouter.path;
      }
      return true;
    });
  },
  // 去掉二级菜单的icon
  // async handleAsyncRouter({commit},{data}){
    // for(let i=0;i<data.length;i++){
      // path不能相同
      // if(data[i].path == "/" || data[i].path == ""){
      //   data[i].path = "/empty"+Math.random();
      // }
      // if(data[i].children){
      //   for(let j=0;j<data[i].children.length;j++){
      //     data[i].children[j].meta.icon = "";
      //   }
      // }
    // }
  //   return data;
  // },
  async filterChildren({commit},{childrenMap, lastRouter}){
    let children = [];
    childrenMap.forEach(async (el) => {
      if (el.children && el.children.length) {
        if (el.component?.toString() === 'ParentView' && !lastRouter) {
          el.children.forEach(async (c) => {
            c.path = el.path + '/' + c.path;
            if (c.children && c.children.length) {
              children = children.concat(await this.dispatch('permission/filterChildren',{childrenMap:c.children, lastRouter:c}));
              return;
            }
            children.push(c);
          });
          return;
        }
      }
      if (lastRouter) {
        el.path = lastRouter.path + '/' + el.path;
        if (el.children && el.children.length) {
          children = children.concat(await this.dispatch('permission/filterChildren',{childrenMap:el.children, lastRouter:el}));
          return;
        }
      }
      children = children.concat(el);
    });
    return children;
  },
  async loadView({commit},{view, name}){
    let res;
    for (const path in modules) {
      const dir = path.split('./')[1].split('.vue')[0];
      if (dir === view) {
        res = createCustomNameComponent(modules[path], { name });
      }
    }
    return res;
  },

  async generateRoutes({commit}){
    const res = await getRouters();
    if(res?.data){
      const { data } = res;
      const sdata = JSON.parse(JSON.stringify(data));
      const rdata = JSON.parse(JSON.stringify(data));
      var sidebarRoutes = await this.dispatch('permission/filterAsyncRouter',{asyncRouterMap:sdata, lastRouter:undefined, type:false});
      // var sidebarRouteList = await this.dispatch('permission/handleAsyncRouter',{data:sidebarRoutes});
      
      // 过滤掉与 defaultRoutes 中重复的路由
      const defaultRouteNames = defaultRoutes.map(route => route.name);
      const filteredSidebarRoutes = sidebarRoutes.filter(route => !defaultRouteNames.includes(route.name));
      
      commit("setSidebarRouters",defaultRoutes.concat(filteredSidebarRoutes));
      const rewriteRoutes = await this.dispatch('permission/filterAsyncRouter',{asyncRouterMap:rdata, lastRouter:undefined, type:true});
      // var rewriteRouteList = await this.dispatch('permission/handleAsyncRouter',{data:rewriteRoutes});
      
      // 过滤掉与 defaultRoutes 中重复的路由
      const filteredRewriteRoutes = rewriteRoutes.filter(route => !defaultRouteNames.includes(route.name));
      
      commit("setRoutesGenerated", true);
      return new Promise((resolve) => resolve(defaultRoutes.concat(filteredRewriteRoutes)));
    }
    else{
      return new Promise((resolve) => resolve([]));
    }
  }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }